import React, { useState } from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core"

import { isMobile } from "../../../../utils/device"

import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Button from "@material-ui/core/Button"

import MoreVertOutlinedIcon from "@material-ui/icons/MoreVertOutlined"

const useStyles = makeStyles(() => ({
	typographyIcon: {
		verticalAlign: "middle",
		display: "inline-flex"
	}
}))

const InstallAppDialog = props => {
	const [visibility, setVisibility] = useState(false)
	const classes = useStyles()
	const { children } = props

	return (
		<>
			<div onClick={() => setVisibility(true)}>{children}</div>
			<Dialog
				onClose={() => setVisibility(false)}
				aria-labelledby="simple-dialog-title"
				open={visibility}
			>
				<DialogTitle>Salvar como aplicativo</DialogTitle>
				<DialogContent dividers>
					<DialogContentText>
						{
							isMobile() && (
								<>
									Toque em
									<MoreVertOutlinedIcon className={classes.typographyIcon} />
									{" "}
									e depois em "Adicionar à tela inicial" para instalar o aplicativo.
								</>
							)
						}
						{
							!isMobile() && (
								<>
									Você precisa abrir essa galeria pelo celular para que consiga salvar como aplicativo.
								</>
							)
						}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => setVisibility(false)}
						variant="contained"
						color="primary"
					>
						Fechar
					</Button>
				</DialogActions>
			</Dialog>
		</>
	)
}

InstallAppDialog.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf([PropTypes.node])
	]).isRequired
}

export default InstallAppDialog
